import React, { Fragment } from "react";

import { TableExpandableCard } from "../../../../../../../components/table/components/TableExpandableCard";
import { DeviceWithType } from "../../../../../../../components/devices/DeviceWithType";
import { OnlineDevicesDropdownActions } from "../onlineDevicesDropdownActions";

export const TableCard = ({ type, identifier, manufacturer }) => {
  return (
    <TableExpandableCard
      showExpand={false}
      content={
        <Fragment>
          <DeviceWithType type={type} identifier={identifier} />
          {manufacturer && (
            <div className={"color-table__cell"}>{manufacturer}</div>
          )}
        </Fragment>
      }
      aside={
        <OnlineDevicesDropdownActions
          identifier={identifier}
          type={type}
          manufacturer={manufacturer}
        />
      }
    />
  );
};
